import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Card } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Constants from "../../../../common/Constants";
import { useTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import MasterList from "../../../common/MasterList";
import { fetchMasterList, fetchMasterListById } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import { formatDate } from "../../../../common/Validations";
import { useNavigate } from "react-router-dom";

const StartJobCardList = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState([]);
  const [machineList, setMachineList] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [toMachineName, setToMachineName] = useState("");
  const [toMachineCode, setToMachineCode] = useState("");

  useEffect(() => {
    if(props.selectedMachineCode){
      setToMachineCode(props.selectedMachineCode);
      setToMachineName(props.selectedMachineName);
    }
    dispatch(
      fetchMasterList(Constants.TRANSACTION.GENERATEJOBCARD.open_jobcard)
    ); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

 // const userData = useSelector((state) => state?.user);
 // const deptCodeList = userData?.data?.departments?.map((entry) => entry.deptCode);


  useEffect(() => {
    let param = {};
    param.url = "getMasterListDataById";
    param.page = Constants.MASTER.MACHINES.name;
    param.id = props.deptCode;

    if (props.deptCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        let filteredMachines = result?.payload?.data.filter(
          (machine) => machine.runningStatus !== "Inuse" && machine.status !== Constants.MASTER.STATUS.Inactive
        );
        setMachineList(filteredMachines);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  let rowsData = props?.rows;
  /*if (userData?.data?.category === Constants.MASTER.USERS.TEAMLEAD) {
    rowsData = props?.rows?.filter(
      (user) => deptCodeList?.includes(user?.toDeptCode)
    );
  }
*/
  const handleRowSelected = ({ selectedRows }) => {
    setSelectedItem([...selectedRows]);
  };

  const startAllJobCards = () => {
    props.fetchCheckList(selectedItem,toMachineCode,toMachineName,true)
  };

  const columnsData = [

    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcard}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_priority"),
      selector: (row) => row.priority,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          {row.priority === "urgent" ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_overview.urgent")}
            </span>
          ) : row.priority === "regular" ? (
            <span className="bg-table-status bg-table-info-status">
              <strong>{t("msg_overview.regular")}</strong>
            </span>
          ) : (
            <>{row.priority}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_quantity"),
      selector: (row) => row.batchTotalQtyDozen,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-text-status">
            {row.originalQuantityPerJobCard} / {row.quantityPerJobCard}
          </span>
        </>
      ),
    },
    {
      name: t("msg_common.status"),
      selector: (row) => row.jobcardStatus,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcardStatus}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_fromDepartment"),
      selector: (row) => row.fromDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.fromDeptCode ? (
            <span className="bg-table-status bg-table-first-status">
              {row.fromDeptCode} - {row.fromDeptName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_toDepartment"),
      selector: (row) => row.toDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-second-status">
            {row.toDeptCode} - {row.toDeptName}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_toMachine"),
      selector: (row) => row.toMachineCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-second-status">
            {row.toMachineCode} - {row.toMachineName}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.sizeCode}</p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.requiredDate"),
      selector: (row) => row.requiredDate,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{formatDate(row.requiredDate)}</p>
        </div>
      ),
    },

  ];


  return (
    <div>
      <Form noValidate>
        <Card className="">
          <Card.Header>
            <Button
              type="button"
              variant="primary"
              className="btn btn-primary btn-xs navigateBackButton"
              onClick={() => navigate("/home")}
            >
              <i class="bi bi-arrow-left back"> </i>
              <span className="back"> {t("msg_common.Back")}</span>
            </Button>

            <h5 className="machineStatusTitle">
              {" "}
              {'Start Multiple JobCard '}
            </h5>
          </Card.Header>
          <Card.Body>

            {rowsData?.length > 0 && (
              <div>
                <Form.Group className="mb-3">
                  <Row>
                    <Col xs={2} md={2}>
                      <Form.Label className="col-form-label">
                        {t("msg_trasaction.msg_idle_status.select_machine")}
                      </Form.Label>
                    </Col>
                    <Col xs={2} md={2}>
                      <DropdownListField
                        id="machineCode"
                        name="machineCode"
                        className="dropdownHive w-full rounded-md"
                        data={machineList}
                        value={
                          toMachineCode
                        }
                        onChange={(e) => {
                          setToMachineCode(e.machineCode);
                          setToMachineName(e.machineName);
                        }}
                        placeholder={"Select To Machine"}
                      />
                    </Col>
                  </Row>
                </Form.Group>

                <MasterList
                  columnsData={columnsData}
                  cardHeader={false}
                  handleAckAllJobCards={props.handleAckAllJobCards}
                  rowsData={props.rows}
                  paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                  pagination
                  handleClose
                  selectableRows={true}
                  handleRowSelected={handleRowSelected}
                />
              </div>
            )}
          </Card.Body>
          <Card.Footer className="text-center machine-status-footer-button">
            <Button
              type="button"
              variant="success"
              size="lg"
              className="btn btn-success"
              onClick={() => startAllJobCards()}
              data-dismiss="modal"

            >
              {t("msg_common.start")}
            </Button>

            <Button
              type="button"
              variant="danger"
              size="lg"
              className="btn btn-danger"
              onClick={() => navigate("/home")}
              data-dismiss="modal"
            >
              {t("msg_common.set_cancel")}
            </Button>
          </Card.Footer>
        </Card>
      </Form>
    </div>
  );
};

export default StartJobCardList;
